__turbopack_context__.v({
  "errorButton": "AlbumErrorState-module-scss-module__svC9gW__errorButton",
  "errorState": "AlbumErrorState-module-scss-module__svC9gW__errorState",
  "errorStateBigMessage": "AlbumErrorState-module-scss-module__svC9gW__errorStateBigMessage",
  "errorStateMessage": "AlbumErrorState-module-scss-module__svC9gW__errorStateMessage",
});
